import { IconSearch, IconX } from '@tabler/icons-react';
import { useRouter } from 'next/navigation';
import React, { useCallback, useEffect, useState } from 'react';
import { Input } from '@/components/ui/input';
import { useFilters } from '@/features/filters/hooks/use-filters';
import { Category } from '@/features/filters/types';
export const SearchBar = () => {
  const [isFocused, setIsFocused] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [results, setResults] = useState<Category[]>([]);
  const [query, setQuery] = useState('');
  const router = useRouter();
  const {
    data: filters
  } = useFilters();
  const handleSearch = useCallback(() => {
    const categoryOptions = filters?.categories || [];
    const filtered = categoryOptions.filter(option => Object.values(option).some(value => typeof value === 'string' && value.toLowerCase().includes(query.toLowerCase())));
    setResults(filtered);
  }, [filters, query]);
  useEffect(() => {
    if (query === '') {
      return;
    }
    handleSearch();
  }, [query, handleSearch]);
  function search(item: Category) {
    router.push(`/search/${item.gender}?category=${item.slug}`);
    setQuery(item.name);
    setIsFocused(false);
  }
  return <div className="w-full relative mr-auto" data-sentry-component="SearchBar" data-sentry-source-file="search-bar.tsx">
      <div className="relative flex items-center">
        <div className="rounded-full z-10 text-gray-700 p-2 flex items-center justify-center absolute inset-y-0 left-0 pl-3">
          <IconSearch className="h-4 w-4 flex-shrink-0 text-gray-700" aria-hidden="true" strokeWidth={3} data-sentry-element="IconSearch" data-sentry-source-file="search-bar.tsx" />
        </div>
        <Input className="border border-gray-200 rounded-full pl-10 pr-20 bg-gray-50 focus:ring focus:ring-indigo-300" id={'search'} value={query} name={'search'} type={'text'} onChange={event => setQuery(event.target.value)} onFocus={() => setIsFocused(true)} onBlur={() => !isHovered && setIsFocused(false)} autoComplete="off" data-sentry-element="Input" data-sentry-source-file="search-bar.tsx" />
        <div className="absolute inset-y-0 right-0 flex items-center pr-3">
          {query.length > 0 && <button className="text-xs p-2 rounded-full" onClick={() => setQuery('')}>
              <IconX className="h-4 w-4 flex-shrink-0 text-gray-500" aria-hidden="true" />
            </button>}
        </div>
      </div>
      {isFocused && query.length > 0 && <div className="w-full bg-white absolute top-12 shadow-lg flex" onMouseEnter={() => setIsHovered(true)}>
          <ul className="w-full">
            {results.length > 0 ? results.map((item, index) => {
          return <li key={index} className="w-full text-base flex border-b border-gray-200">
                    <button onClick={() => search(item)} className="cursor-pointer w-full flex justify-between items-center hover:bg-indigo-50 px-4 py-2">
                      {item.name}
                      <p className="text-primary text-sm">{item.gender}</p>
                    </button>
                  </li>;
        }) : <div className="p-4 h-16 flex items-center text-gray-600">
                No results for &quot;
                <span className="text-primary font-medium">{query}</span>&quot;
              </div>}
          </ul>
        </div>}
    </div>;
};